import { $t } from '@/i18n';
import XyPageletRenderer from './xy-pagelet-renderer.vue';
import XyPageletSchema from './xy-pagelet-schema';
import { meta as XyInnerPageletSelectorMeta } from './xy-inner-pagelet-selector.vue';
import { XyPageletPropsEditorMeta } from '../uicorePlugin/paramsFormComponents';
import Vue from 'vue';
import logger from '@utils/logger';

export default {
  component: XyPageletRenderer,
  componentForDesign: XyPageletRenderer,
  category: $t('k_94e14a60'),
  id: 'xy-pagelet-renderer',
  events: [
    {
      id: 'presetEventA',
      name: $t('k_a6129a05'),
      desc: $t('k_db697003'),
    },
    {
      id: 'presetEventB',
      name: $t('k_e5868a4d'),
      desc: $t('k_aa5b7ad3'),
    },
    {
      id: 'presetEventC',
      name: $t('k_81dc7095'),
      desc: $t('k_f1f83a1c'),
    },
    {
      id: 'presetEventD',
      name: $t('k_7a3fc12a'),
      desc: $t('k_2ce9658c'),
    },
    {
      id: 'presetEventE',
      name: $t('k_8d6b2f84'),
      desc: $t('k_7d857536'),
    },
  ],
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-page-let-renderer_1636364733590.png',
  slots: [],
  display: 'block',
  visible: false,
  name: $t('k_12934ef'),
  order: 1,
  propPanel: {
    XyInnerPageSelector: XyInnerPageletSelectorMeta,
    XyPageletPropsEditor: XyPageletPropsEditorMeta,
  },
  readme: '',
  propsSchema: XyPageletSchema,
  getActions({ modifyComp }) {
    return [
      {
        title: $t('k_f4be42a8'),
        icon: 'fa fa-refresh',
        async execute() {
          await modifyComp((c) => {
            logger.info(c);
            Vue.set(c, 'type', 'xy-page-container');
            Vue.set(c.props, 'type', 'pagelet');
          });
        },
      },
    ];
  },
};
